import { createSlice } from '@reduxjs/toolkit';

export const blogsSlice = createSlice({
    name: "blogs",
    initialState: [],
    reducers: {
        set: (state, action) => {
            state = action.payload;
            return state;
        }
    }
})

export const blogsActions = blogsSlice.actions;

export default blogsSlice.reducer;